module.exports = __webpack_public_path__ + "1ab852c2b04d172ec1448b26865cbe42.png";